import _defineProperty from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import primitives from '@primer/primitives';
import { t as theme$2 } from './utils/theme2.js';
var lineHeights = primitives.typography.normal.lineHeight;
var animation = {
  easeOutCubic: 'cubic-bezier(0.33, 1, 0.68, 1)'
};
var breakpoints = ['544px', '768px', '1012px', '1280px'];
var fonts = {
  normal: theme$2.fontStack(['-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Noto Sans', 'Helvetica', 'Arial', 'sans-serif', 'Apple Color Emoji', 'Segoe UI Emoji']),
  mono: theme$2.fontStack(['SFMono-Regular', 'Consolas', 'Liberation Mono', 'Menlo', 'Courier', 'monospace'])
};
var fontWeights = {
  light: 300,
  normal: 400,
  semibold: 500,
  bold: 600
};
var borderWidths = [0, '1px'];
var radii = ['0', '3px', '6px', '100px'];
var sizes = {
  small: '544px',
  medium: '768px',
  large: '1012px',
  xlarge: '1280px'
};
var fontSizes = ['12px', '14px', '16px', '20px', '24px', '32px', '40px', '48px', '56px'];
var space = ['0', '4px', '8px', '16px', '24px', '32px', '40px', '48px', '64px', '80px', '96px', '112px', '128px'];
var colorSchemes = Object.entries(primitives.colors).reduce(function (acc, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      variables = _ref2[1];

  var _theme$2$partitionCol = theme$2.partitionColors(variables),
      colors = _theme$2$partitionCol.colors,
      shadows = _theme$2$partitionCol.shadows;

  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, {
    colors: theme$2.omitScale(colors),
    shadows: theme$2.omitScale(shadows)
  }));
}, {});
var theme = {
  animation: animation,
  borderWidths: borderWidths,
  breakpoints: breakpoints,
  fonts: fonts,
  fontSizes: fontSizes,
  fontWeights: fontWeights,
  lineHeights: lineHeights,
  radii: radii,
  sizes: sizes,
  space: space,
  colorSchemes: colorSchemes
};
var theme$1 = theme; // NOTE: for now, ThemeColors and ThemeShadows are handcrafted types. It would be nice if these
// were exports from primitives (or a different shape but derived from those exports).

export { theme$1 as default };